import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

export const graphemeSimilarGraphemeTable = staticTable(
  "grapheme_similar_grapheme",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),
    index: integer("index").notNull(),
    similarGraphemeId: integer("similar_grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),
  },
  (table) => [
    index("grapheme_similar_grapheme_grapheme_id_idx").on(table.graphemeId),
    index("grapheme_similar_grapheme_similar_grapheme_id_idx").on(table.similarGraphemeId),
  ],
);

export type GraphemeSimilarGrapheme = typeof graphemeSimilarGraphemeTable.$inferSelect;
